import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'trimString',
})
export class TrimStringPipe implements PipeTransform {
  transform(value: string, maxLength = 40): string {
    if (!value) return '';

    // Remove HTML tags
    const plainText = value.replace(/<\/?[^>]+(>|$)/g, '');

    // Trim the string and append ellipsis if necessary
    return plainText.length > maxLength
      ? plainText.substring(0, maxLength) + '...'
      : plainText;
  }
}
